import { useEffect, useRef, useState } from 'react'
import { windowContext } from 'src/util'

const useIntersection = ({ root, rootMargin, threshold } = { root: null, rootMargin: '0px', threshold: 0 }) => {
  const [entry, updateEntry] = useState<IntersectionObserverEntry>(null)
  const [node, setNode] = useState(null)

  const observer = useRef(
    windowContext() &&
    new window.IntersectionObserver(([entry]) => updateEntry(entry), {
      root,
      rootMargin,
      threshold
    })
  )

  useEffect(
    () => {
      const { current: currentObserver } = observer
      currentObserver.disconnect()

      if (node) currentObserver.observe(node)

      return () => currentObserver.disconnect()
    },
    [node]
  )

  return { register: setNode, entry }
}

export default useIntersection
